import * as React from "react"
import { graphql } from "gatsby";
import Layout from "../../components/Layout"
import { AwardsRecognition } from "../../components/PageEnd/PageEnd"
import MainPageHeader from "../../components/MainPageHeader/MainPageHeader"
import MainPageIntro from "../../components/MainPageIntro/MainPageIntro";
import MetaHead from "../../components/MetaHead";

const WhoWeArePage = ({data}) => {
  return (
      <Layout>
        <MainPageHeader 
          title={<><span className="font-extralight">Who</span> we are</>} 
          image={data.page.HeroImage.url} 
          gatsbyImage={data?.page?.HeroImage?.localFile?.childImageSharp?.gatsbyImageData}
          backLabel={data.page.ParentPage.Title}
          backLink={"/" + data.page.ParentPage.slug}
          accentColour={data.page.AccentColour}
        />
        <MainPageIntro 
          title={data?.page?.IntroTitle}
          introText={data?.page?.IntroText?.data?.IntroText}
          introImage={data?.page?.IntroImage?.url}
          introGatsbyImage={data?.page?.IntroImage?.localFile?.childImageSharp?.gatsbyImageData}
          accentColour={data?.page?.AccentColour}
          ctaLabel={data?.page?.CTALabel}
          ctaLink={data?.page?.CTALink}
        /> 
        
        <AwardsRecognition />
      </Layout>
  )
}

export default WhoWeArePage

export const Head = ({data}) => <MetaHead
                                  title={'The Information Lab - Who We Are'}
                                  description={"The Information Lab: Empowering individuals and companies to work effectively with data since 2010. Premier partners of Tableau and Alteryx in the UK and across eight European countries."}
                                  image={data?.page?.IntroImage?.url}
                                />

export const query = graphql`
  query WhoWeAreQuery {
  page: strapiTilWwwPage(slug: {eq: "til"}) {
    Title
    IntroTitle
    AccentColour
    HeroImage {
      url
      localFile {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, formats: WEBP)
        }
      }
    }
    IntroImage {
      url
      localFile {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, formats: WEBP)
        }
      }
    }
    IntroText {
      data {
        IntroText
      }
    }
    CTALabel
    CTALink
    ParentPage {
      Title
      slug
    }
    TextBlock {
      Title
      TextPosition
      id
      SideGraphicImage {
        url
      }
      TextBlock {
        data {
          TextBlock
        }
      }
      CTALabel
      CTALink
    }
  }
}
`
